/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateCheckout201ResponseAllOfData } from './CreateCheckout201ResponseAllOfData';
import {
    CreateCheckout201ResponseAllOfDataFromJSON,
    CreateCheckout201ResponseAllOfDataFromJSONTyped,
    CreateCheckout201ResponseAllOfDataToJSON,
} from './CreateCheckout201ResponseAllOfData';

/**
 * 
 * @export
 * @interface CreateCheckout201Response
 */
export interface CreateCheckout201Response {
    /**
     * 
     * @type {CreateCheckout201ResponseAllOfData}
     * @memberof CreateCheckout201Response
     */
    data: CreateCheckout201ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof CreateCheckout201Response
     */
    meta: object;
}

/**
 * Check if a given object implements the CreateCheckout201Response interface.
 */
export function instanceOfCreateCheckout201Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function CreateCheckout201ResponseFromJSON(json: any): CreateCheckout201Response {
    return CreateCheckout201ResponseFromJSONTyped(json, false);
}

export function CreateCheckout201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCheckout201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': CreateCheckout201ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function CreateCheckout201ResponseToJSON(value?: CreateCheckout201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CreateCheckout201ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

